export default __webpack_public_path__ + "static/radeet-73c743a56591819dd18d5043d7db17bd.png";